import { ClientRegistry } from '../components';
import {
  ClientFilteredComponentSystem,
  FilteredClientComponentSystemUpdateEntityArgs,
} from './ClientBase';

export class FootstepParticleLoadingSystem extends ClientFilteredComponentSystem {
  public componentClasses: (keyof ClientRegistry)[] = ['SpritesheetSprite', 'HasWalkingAnimation'];

  private requestedSheets = new Map<number, string>();

  updateEntity({ world, entityId }: FilteredClientComponentSystemUpdateEntityArgs): void {
    const spritesheetSprite = world.getComponent(entityId, 'SpritesheetSprite')!;
    const spritesheetId = spritesheetSprite.spritesheetId;

    const lastRequested = this.requestedSheets.get(entityId);

    if (lastRequested !== spritesheetId) {
      if (!lastRequested) {
        world.registerOnEntityDestroyed(entityId, (id) => {
          this.requestedSheets.delete(id);
        });
      }

      this.requestedSheets.set(entityId, spritesheetId);

      // Trigger load of point data
      void this.clientServices.spritesheet.loadPoint(spritesheetId, 'FootstepParticlePoint');
    }
  }
}
